import { Stack } from '@mui/material';
import { useDispatch } from 'react-redux';

import { Text } from '../../../../../../shared/uiComponents';
import { SkillProperties } from '../../../../../../redux/API/ClientAPIHelpers/skillAreaProperties';
import { TEXT } from '../../../../../../shared/Helpers/colors';
import { DispatchProperties } from '../../../../../../redux/store';
import { setSkillAreaId } from '../../../../../../redux/State/clientSlice/skillAreaSlice';
import { SkillAcquisitionHeaderActions } from './SkillAccordionItemActions';
import { useScreenWidth } from '../../../../../../shared/Helpers/hooks';
import { LightBulbIcon } from '../../../../../../shared/Assets/svgIcons';

export const ProgramsHeader = ({ item }: { item: SkillProperties }) => {
	const dispatch = useDispatch<DispatchProperties>();
	const screenWidth = useScreenWidth();
	const isMobile = screenWidth <= 768;

	const onClick = () => {
		// if (choosenId === item.id) {
		//   dispatch(setSkillAreaId(""));
		// } else {
		dispatch(setSkillAreaId(item.id));
		// }
	};

	return (
		<Stack onClick={onClick} flexDirection="row" justifyContent="space-between" width="100%" position="relative">
			<Stack flexDirection="row" gap={2}>
				{!isMobile && (
					<div className="skillIconWrapper">
						<LightBulbIcon />
					</div>
				)}
				<div>
					<Text title={item.name} fontWeight="semiBold" color={TEXT.PRIMARY} type="psm" />
					<Text
						title={`Programs: ${item?.numberOfPrograms ?? 0}`}
						fontWeight="medium"
						type="pxs"
						color={TEXT.TERTIARY}
					/>
				</div>
			</Stack>
			<SkillAcquisitionHeaderActions item={item} />
		</Stack>
	);
};

export const MaintenanceHeader = ({ item }: { item: SkillProperties }) => {
	const dispatch = useDispatch<DispatchProperties>();
	const screenWidth = useScreenWidth();
	const isMobile = screenWidth <= 768;

	const onClick = () => {
		// if (choosenId === item.id) {
		//   dispatch(setSkillAreaId(""));
		// } else {
		dispatch(setSkillAreaId(item.id));
		// }
	};

	return (
		<Stack onClick={onClick} flexDirection="row" justifyContent="space-between" width="100%" position="relative">
			<Stack flexDirection="row" gap={2}>
				{!isMobile && (
					<div className="skillIconWrapper">
						<LightBulbIcon />
					</div>
				)}
				<div>
					<Text title={item.name} fontWeight="semiBold" color={TEXT.PRIMARY} type="psm" />
					<Text
						title={`Targets: ${item?.numberOfMasteredTargets ?? 0}`}
						fontWeight="medium"
						type="pxs"
						color={TEXT.TERTIARY}
					/>
				</div>
			</Stack>
			<SkillAcquisitionHeaderActions item={item} />
		</Stack>
	);
};
